const posPaymentMethodEnum = Object.freeze({
    CASH          : 5,
    CARD          : 10,
    MOBILE_BANKING: 15,
    OTHER         : 20
});
export default posPaymentMethodEnum;